<template>
  <div class="list-view">
    <ul
      class="ship-list reset-list"
    >
      <li class="ship-list__row ship-list__row--head">
        <div class="ship-list__item ship-list__item--ship-name flex-col flex-col--20">
          {{ $t('Ship name') }}
        </div>
        <div class="ship-list__item ship-list__item--imo
          flex-col flex-col--15 text--right"
        >
          {{ $t('IMO') }}
        </div>
        <div class="ship-list__item ship-list__item--ucrn
          flex-col flex-col--20 text--right"
        >
          {{ $t('UCRN') }}
        </div>

        <div class="ship-list__item ship-list__item--time
          flex-col flex-col--15 text--right"
        >
          {{ $t('Date') }}
        </div>
        <div class="ship-list__item ship-list__item--approved
          flex-col flex-col--25 text--center"
        >
          {{ $t('Delivery entitlement') }}
        </div>
      </li>
      <ListItem
        v-for="(ship, key) in ships"
        :key="key"
        :ship="ship"
        class="ship-list__row"
      />
    </ul>
    <LoadingIndicator
      v-if="$store.state.loading"
      :show-text="$t('Loading ship data')"
    />
  </div>
</template>

<script>
import LoadingIndicator from '@/Modules/LoadingIndicator/Components/LoadingIndicator.vue';
import ListItem from '@/Modules/List/Components/ListItem.vue';

export default {
  name: 'List',
  components: {
    ListItem,
    LoadingIndicator,
  },
  props: {
    ships: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.list-view {
  height: 100%;
  overflow-y: auto;
  background-color: $white;
  padding: 2rem;
  @include media-breakpoint-up(md) {
    padding: 3rem;
  }
}

.ship-list {
  width: 100%;
  &__row {
    &:first-child {
      border-bottom: .1rem solid $black;
      border-top: none;
      margin-bottom: -.1rem;
      position: relative;
      z-index: 1;
    }
    &--head {
      display: none;
      @include media-breakpoint-up(md) {
        display: flex;
        font-family: $font-medium;
        text-transform: uppercase;
      }
    }
  }
  &__item {
    &--ship-name {
      flex: 1;
      @include media-breakpoint-down(md) {
        ~ .ship-list__item {
          display: none;
        }
      }
    }
    &--approved {
      padding-right: 0;
    }
  }
}
</style>
